<app-page hidePageTitle hideBreadcrumb [loadingWholePage]="true"></app-page>
